import React from "react";
import { withStyles } from "@material-ui/core";
import UndockIcon from "@material-ui/icons/OpenInNew";
import PopInIcon from "../../icons/PopIn";
import { trackEvent } from "../../../components/common/AppInsightsEventTracking";
import styles from "./styles";
import appConstant from "../../../appConstants";

class Popout extends React.Component {
  popOut = () => {
    const quickFilterContent = this.props.stack.parent.getItemsById(
      appConstant.layout.QuickFilter
    );
    let quickFilterContainer = null;
    let quickFilterwidth = null;
    if (quickFilterContent.length) {
      quickFilterContainer = quickFilterContent[0].container;
      quickFilterwidth = quickFilterContainer.width;
    }

    if (this.props.stack.layoutManager.isSubWindow) {
      window && window.close();
    } else {
      this.props.stack.popout();
      if (quickFilterContainer) {
        quickFilterContainer.setSize(quickFilterwidth);
      }
    }

    const userProfile = this.props.userData.userProfile;
    trackEvent("MultiMonitor", userProfile);
  };

  render() {
    const { isSubWindow } = this.props.stack?.layoutManager;
    const { classes } = this.props;
    return (
      <div
        className={`${classes.headerIconStyles} ${classes.iconLayout} glHeaderIcons`}
        onClick={this.popOut}
        title={isSubWindow ? "Pop In" : "Pop Out"}
      >
        {isSubWindow ? <PopInIcon /> : <UndockIcon />}
      </div>
    );
  }
}
export default withStyles(styles)(Popout);
